import React, { useState, useEffect } from "react"
import { MainSearchContainer, Input } from "./main-search-styled"
import PropTypes from "prop-types"
import SearchResults from "gatsby-theme-blank/src/components/search-results"
import root from "window-or-global"
import { mainSearch, fieldAndButton, inputSearch } from "../header.module.scss"
import Banner from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Layout/Header/Banner/banner"

const MainSearch = ({ open, children, isIndex }) => {
  const [results, setResults] = useState([])
  const [searchQuery, setSearchQuery] = useState("")
  useEffect(() => {
    if (searchQuery && root.__LUNR__) {
      root.__LUNR__.__loaded.then((lunr) => {
        const refs = lunr.fr.index.search(
          `${searchQuery}^100 ${searchQuery}*^10 ${searchQuery}~2`
        )
        const posts = refs.map(({ ref }) => lunr.fr.store[ref])
        setResults(posts)
      })
    }
  }, [searchQuery])
  if (open) {
    return (
      <>
        <MainSearchContainer className={mainSearch}>
          <div className={fieldAndButton}>
            <Input
              type="search"
              id="search-input"
              name="keywords"
              className={inputSearch}
              onChange={(element) => setSearchQuery(element.target.value)}
              value={searchQuery}
              placeholder="Tapez votre recherche"
            />
          </div>
        </MainSearchContainer>
        {searchQuery !== "" && (
          <>
            <Banner isIndex={isIndex} />
            <SearchResults query={searchQuery} resultats={results} />
          </>
        )}
        {searchQuery === "" && (
          <div>
            <main>
              <Banner isIndex={isIndex} />
              {children}
            </main>
          </div>
        )}
      </>
    )
  }
  return (
    <>
      <div>
        <main>
          <Banner isIndex={isIndex} />
          {children}
        </main>
      </div>
    </>
  )
}

MainSearch.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  isIndex: PropTypes.bool,
}

export default MainSearch
